<template>
  <article class="submit_success">
    <section class="tip-result">
      <i class="result-ico icon-tipico-ok" :class="{'icon-error': type === 'error', 'icon-plaint': type === 'warn'}"></i>
      <p class="result-hd">{{title}}</p>
      <slot></slot>
    </section>
    <section class="operate_btn" v-if="btnList.length">
      <a href="javascript:void(0);" v-for="(item, index) in btnList" :key="index" @click.stop="go(item.link)" :class="{'blue_btn': index === 0}">{{item.name}}</a>
      <slot name="btn"></slot>
      <a href="javascript:void(0);" @click.stop="close" v-if="showMiddleCloseBtn">返回首页</a>
    </section>
    <section class="btn-bottom" v-else>
      <div class="btn-fix" v-if="showBottomCloseBtn">
        <a class="btn" @click.stop="close">返回首页</a>
      </div>
    </section>
    <slot name="bottom"></slot>
  </article>
</template>
<script>

export default {
  props: {
    btnList: {
      type: Array,
      default: function () {
        return []
      }
    },
    type: {// default: 默认(勾)，error: 错误（叉），warn：警告（感叹号）
      type: String,
      default: 'default'
    },
    title: {
      type: String,
      required: true,
      default: '已保存'
    },
    showMiddleCloseBtn: {
      type: Boolean,
      default: false
    },
    showBottomCloseBtn: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    go(url) {
      this.$router.push({ path: url })
    },
    close() {
      this.$wechat.promise.then(wx => {
        wx.closeWindow()
        this.$emit('close')
      }, wx => {
        window.console.log('微信JSSDK校验错误:', JSON.stringify(wx.res))
      })
    }
  }
}

</script>
<style lang="less">
@import "../../stylesheets/modules/components/success.less";
</style>
